<template>
  <v-row>

    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined 
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Nombre de la edición:</h3>
          </v-col>

          <v-col
            cols="12"
            xl="8"
            md="8"
            sm="8"
            xs="12"
          >
            <v-text-field
              ref="name"
              v-model="name"
              outlined
              :maxlength="75"
              :counter="75"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre no debe tener mas de 75 caracteres']"
              :error-messages="errorMessages"
              label="Nombre de la ediciòn"
              required
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            xl="4"
            md="4"
            sm="4"
            xs="12"
          >
            <v-text-field
              ref="short_name"
              v-model="short_name"
              outlined
              :maxlength="20"
              :counter="20"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre corto no debe tener mas de 20 caracteres']"
              label="Nombre corto"
              required
            ></v-text-field>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateEdition()"
        >
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="error"
      persistent
      max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                class="pa-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'editEdition',

    data: (vm) => ({
      loading:true,
      loading_update:false,
      show:false,
      edition_id:null,
      errorMessages: '',
      edition:null,

      name:'',
      short_name:null,
      description:null,

      error:false,
      errors:[],

      date: null,
      dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    watch: {
      date (val) {
        console.log(val)
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    methods:{
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async getEdition(){
        await axios.get('admin/editions/'+this.edition_id).then(response =>{
          this.edition = response.data.edition

          this.name = this.edition.name
          this.short_name = this.edition.short_name
          this.description = this.edition.description
          this.published = (this.edition.published=='1')?true:false

          this.start_date = this.edition.start_date
          this.start_time= this.edition.start_time
          
          this.finish_date = this.edition.finish_date
          this.finish_time= this.edition.finish_time

          this.terms_and_conditions= this.edition.terms_and_conditions

          this.loading=false
          this.show=true

        }).catch(error => {
          console.log(error);
        })
      },

      dateConvert(date){
        const parts = date.split(/[- :]/);
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      },

      async updateEdition(){
        
        this.loading_update=true
        this.error = false
        this.errors = []
        this.validate()

        try {
          await axios.put('admin/editions/'+this.edition_id,{
            name: this.name, 
            short_name: this.short_name,
            description:this.description,
            pre_incubation: false, 
            incubation: false, 
            pre_aceleration: false,
            published: this.published,
            start_date: this.start_date,
            start_time: this.start_time,
            finish_date: this.finish_date,
            finish_time: this.finish_time,
            terms_and_conditions: this.terms_and_conditions
            }).then(() =>{
              if(this.errors.length===0){
                this.$router.push({ name: 'editEdition' })  
              }
            })
          } 
        catch (error) {
          //console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          Object.values(error.response.data.errors).forEach(error => {
            this.errors.push(error[0])
          })
        }

        if(this.errors.length!=0){
          this.loading_update=false
          this.error=true
        }
      },

      validate(){
        if(this.published){
          if(!this.name){
            this.errors.push('Por favor ingrese el nombre de la edición.')
          }
            
          if(!this.start_date){
            this.errors.push('Por favor ingrese la fecha de inicio.')
          }

          if(!this.start_time){
            this.errors.push('Por favor ingrese la hora de inicio.')
          }

          if(!this.finish_date){
            this.errors.push('Por favor ingrese la fecha de finalización.')
          }

          if(!this.finish_time){
            this.errors.push('Por favor ingrese la hora de finalización.')
          }

          if(this.finish_date<this.start_date){
            this.errors.push('Por favor revise las fechas de inicio y fin.')
          }

          if(this.finish_date==this.start_date){
            if(this.finish_time<=this.start_time){
              this.errors.push('Por favor revise la hora de inicio y fin.')
            }
          }
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getEdition()
    },
  }
</script>